import { Home, RefreshCw } from "lucide-react"
import { Button } from "@/components/ui/button"

interface Props {
  error?: Error
}

// Both buttons do a real page load. The usual cause of this page is a page
// file renamed by a deploy, and only a reload fetches the new names; a router
// <Link> or a boundary reset would just render the same failed import again.
export default function ServerErrorPage({ error }: Props) {
  function refresh() {
    window.location.reload()
  }
  return (
    <div className="min-h-screen relative grid place-items-center bg-[var(--color-bg-subtle)] px-6 overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 opacity-50"
        style={{
          backgroundImage: "radial-gradient(circle, var(--color-border) 1px, transparent 1px)",
          backgroundSize: "24px 24px",
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(60% 60% at 50% 30%, rgba(239,68,68,0.08) 0%, transparent 60%)",
        }}
      />

      <div className="relative z-10 max-w-md text-center">
        <div className="font-display text-8xl font-bold tracking-tight text-[var(--color-danger)]">
          500
        </div>
        <h1 className="mt-4 font-display text-2xl font-semibold tracking-tight text-foreground">
          Something went wrong
        </h1>
        <p className="mt-2 text-sm text-[color:var(--color-text-muted)]">
          Our servers hit a snag. Please try again in a moment.
        </p>
        {error && import.meta.env.DEV ? (
          <pre className="mt-4 max-h-32 overflow-auto rounded-md border border-[var(--color-border)] bg-card p-3 text-left text-[11px] text-[color:var(--color-text-secondary)]">
            {error.message}
          </pre>
        ) : null}
        <div className="mt-8 flex items-center justify-center gap-2">
          <Button onClick={refresh}>
            <RefreshCw className="h-4 w-4" />
            Refresh page
          </Button>
          <Button variant="outline" asChild>
            <a href="/">
              <Home className="h-4 w-4" />
              Go home
            </a>
          </Button>
        </div>
      </div>
    </div>
  )
}
